import * as RadixSelect from '@radix-ui/react-select'
import * as React from 'react'

import { SelectMenuContent } from './SelectMenuContent'
import { SelectMenuContext } from './SelectMenuContext'
import { SelectMenuItem } from './SelectMenuItem'
import { SelectMenuLabel } from './SelectMenuLabel'
import { SelectMenuSeparator } from './SelectMenuSeparator'
import { SelectMenuTrigger } from './SelectMenuTrigger'

type SelectMenuProps = React.ComponentProps<typeof RadixSelect.Root> & {
  size?: 'sm' | 'md' | 'lg'
  theme?: 'white' | 'grey'
  state?: 'error'
}

const SelectMenuRoot = ({
  size = 'md',
  theme = 'grey',
  state,
  children,
  ...props
}: SelectMenuProps) => (
  <SelectMenuContext.Provider value={{ size, theme, state }}>
    <RadixSelect.Root {...props}>{children}</RadixSelect.Root>
  </SelectMenuContext.Provider>
)

export const SelectMenu = Object.assign(SelectMenuRoot, {
  Trigger: SelectMenuTrigger,
  Content: SelectMenuContent,
  Item: SelectMenuItem,
  Group: RadixSelect.Group,
  Label: SelectMenuLabel,
  Separator: SelectMenuSeparator
})
